// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"90ff99af","396":"84d29af1","695":"b427cb7f","974":"8030c4a6"}[chunkId] + ".chunk.css";
};